export default "__VITE_ASSET__CrcKJTL8__"